<template>
  <material-list ></material-list>
</template>

<script>
import materialList from "./components/materialList";
export default {
  data() {
    return {};
  },
  components: { materialList },
  methods: {},
  computed: {},
};
</script>

<style lang="less" scoped>
</style>
